const C = require("../constants");
const initial_data = {
    open: false,
    ticket: {id:null, code:null}
};

function TicketHistoryReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TICKET_HISTORY_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default TicketHistoryReducer;


// WEBPACK FOOTER //
// ./src/reducers/TicketHistoryReducer.js